<template>
    <b-list-group flush>
        <b-list-group-item
            v-for="item in events"
            v-show="!loading"
            :key="item.status"
            class="event-list cursor-pointer border-0"
            @click="view(item.status)"
        >
            <b-row>
                <b-col
                    cols="1"
                    class="px-0"
                >
                    <event-status
                        v-model="item.status"
                        circle
                    />
                </b-col>
                <b-col
                    v-if="!short"
                    cols="5"
                >
                    <div class="name nowrap">
                        {{ item.status }}
                    </div>
                </b-col>
                <b-col
                    :cols="sizeColumn"
                    class="pr-0 text-right"
                >
                    <event-status-count
                        :title="item.status"
                        :count="item.count"
                        :warning="isWarning(item)"
                        :danger="isDanger(item)"
                    />
                </b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item
            v-show="loading"
            class="w-100 text-center"
        >
            <b-spinner small />
        </b-list-group-item>
    </b-list-group>
</template>

<script>
import EventStatus from '@/components/orders/events/Status';
import EventStatusCount from '@/components/events/StatusCount';
import apiUrl from '@/helpers/apiUrl';

const ONE_SECOND = 1000;
const FIFTEEN_ITEMS = 15;
const ONE_HUNDRED_ITEMS = 100;

export default {
    name: 'EventStatusGroup',
    components: {
        EventStatusCount,
        EventStatus,
    },

    props: {
        'short': {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            loading: true,
            events: [
                {
                    status: 'pending',
                    count: 0,
                },
                {
                    status: 'ready',
                    count: 0,
                },
                {
                    status: 'queue',
                    count: 0,
                },
                {
                    status: 'process',
                    count: 0,
                },
                {
                    status: 'waiting',
                    count: 0,
                },
                {
                    status: 'fail',
                    count: 0,
                },
            ],

            intervalVal: 20,
            interval: null,
        };
    },

    computed: {
        sizeColumn: vm => !vm.short ? '5' : '10',
    },

    methods: {
        getInfo: async function() {
            const response = await this.axios.get(apiUrl.events.listCountNotFinished);
            this.events.forEach(item => {
                const type = response.data.find(event => event.status === item.status);
                item.count = type ? type.count : 0;
            });
            this.loading = false;
        },

        view: function(status) {
            this.$router.push({ name: 'EventList', query: { status } }).catch(() => {});
        },

        start: function() {
            this.interval = setInterval(() => {
                this.getInfo();
            }, this.intervalVal * ONE_SECOND);
        },

        stop: function() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },

        isWarning: function(item) {
            return (item.status === 'fail' && item.count > 0) || item.count > FIFTEEN_ITEMS;
        },

        isDanger: function(item) {
            return (item.status === 'fail' && item.count > FIFTEEN_ITEMS) || item.count > ONE_HUNDRED_ITEMS;
        },
    },

    mounted: async function() {
        await this.getInfo();
        this.start();
    },

    destroyed() {
        this.stop();
    },
};
</script>

<style lang="scss" scoped>
    .name {
        white-space: nowrap;

        &:first-letter {
            text-transform: uppercase;
        }
    }
    .event-list {
        padding: 0.5em 2em;
    }
</style>